import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {

  courses = [
    { name: 'B.A.', title: 'Bachelor of Arts', image: 'assets/img/courses/ba.jpg' },
    { name: 'B.COM.', title: 'Bachelor of Commerce', image: 'assets/img/courses/bcom.jpg' },
    { name: 'M.A.', title: 'Master of Arts', image: 'assets/img/courses/ma.jpg' },
    { name: 'M.Com.', title: 'Master of Commerce', image: 'assets/img/courses/mcom.jpg' }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
